"use client";

import { setOpenMenu } from "@/store/drawerMenuOpenSlice";
import { useAppDispatch } from "@/store/hooks";
import { AppState } from "@/store/store";
import Link from "next/link";
import { useSelector } from "react-redux";
import style from "./lowerNavigationBar.module.scss";

import AllProductsIcon from "public/next-public/common/icons/all-products-icon.svg";
import DealsIcon from "public/next-public/common/icons/deals-icon.svg";
import NewArrivalsIcon from "public/next-public/common/icons/new-arrivals-icon.svg";
import TopSellersIcon from "public/next-public/common/icons/top-sellers-icon.svg";

type NavItemBase = {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  isActive: boolean;
  prefetch?: boolean;
};

type NavItemProps = NavItemBase & ({ href: string; onClick?: never } | { href?: never; onClick: () => void });

function NavItem(props: NavItemProps) {
  const { icon: Icon, label, isActive, prefetch = true } = props;

  if ("onClick" in props && props.onClick) {
    return (
      <button type="button" onClick={props.onClick} className={`${style.navItem} ${isActive ? style.active : ""}`}>
        <div className={style.iconContainer}>
          <Icon className={style.icon} />
        </div>
        <span className={style.label}>{label}</span>
      </button>
    );
  }

  return (
    <Link href={props.href} prefetch={prefetch} className={`${style.navItem} ${isActive ? style.active : ""}`}>
      <div className={style.iconContainer}>
        <Icon className={style.icon} />
      </div>
      <span className={style.label}>{label}</span>
    </Link>
  );
}

export default function LowerNavigationBar() {
  const dispatch = useAppDispatch();
  const openMenu = useSelector((state: AppState) => state.drawerMenuOpenSlice.openMenu);

  const handleDealsClick = () => {
    dispatch(setOpenMenu("deals"));
  };

  const navItems: NavItemProps[] = [
    {
      href: "/ec/dental-supplies",
      icon: AllProductsIcon,
      label: "All Products",
      isActive: false,
      prefetch: false,
    },
    {
      icon: DealsIcon,
      label: "Deals",
      isActive: openMenu === "deals",
      onClick: handleDealsClick,
    },
    {
      href: "/top-sellers",
      icon: TopSellersIcon,
      label: "Top Sellers",
      isActive: false,
    },
    {
      href: "/new-arrivals",
      icon: NewArrivalsIcon,
      label: "New Arrivals",
      isActive: false,
    },
  ];

  return (
    <nav className={style.lowerNavigationBar}>
      {navItems.map((item) => (
        <NavItem key={"href" in item ? item.href : item.label} {...item} />
      ))}
    </nav>
  );
}
